import { schemas } from '#oaf_schema.registry';
import { IS_DEVELOPMENT, PUBLIC_URL } from '~/config';
import { ERROR_ROUTE, navigate } from '../stores/routerStore';
import { logger } from './logger';
export const ERROR_CODES = {
  CLIENT_FORBIDDEN: 403,
  // APPX Specific Errors (any code above 3000)
  AUTH_FAILED: 3000,
  BAD_PUBLISHER: 3001,
  FEATURE_FLAGS_MISSING: 3002,
  LISTING_VALIDATION_RESULT_MISSING: 3003,
  PRICING_VALIDATION_RESULT_MISSING: 3004,
  UNRESPONSIVE_SERVER: 3005,
  MISSING_TRIAL_TEMPLATE: 3006,
  MISSING_SOLUTION: 3007,
  FAILED_LOGOUT: 3008,
  UNKNOWN_LISTING_TYPE: 3009,
  MISSING_LISTING_EDITOR_STEP_COMPONENT: 3010,
  MISSING_LISTING_SCHEMA_STEP_ERROR_MAP: 3011,
  NOT_IMPLEMENTED: 3012,
  SECURITY_REVIEW_VALIDATION_RESULT_MISSING: 3013,
  INVALID_MARKETPLACE: 3014,
  FAILED_TO_SAVE_PUBLISHER_ON_LISTING_DETAIL_INIT: 3015
};
export function throwDevelopmentOrLog(error) {
  if (IS_DEVELOPMENT) {
    throw error;
  } else {
    logger.error(error.message, {
      type: 'EXCEPTION',
      name: error.name,
      stack: error.stack
    });
  }
}
export function handleException(exception, context) {
  if (exception instanceof Error) {
    logger.error(`[${context}] Error: Name=[${exception.name}],Message=${exception.message},Stack=${exception.stack}`);
  } else {
    logger.error(`[${context}] Exception: Type=[${typeof exception}],Value=${exception}`);
  }
}
export function unresponsiveServerError(context) {
  logger.error(`Unresponsive server error${context ? `: ${context}` : ''}`);
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.UNRESPONSIVE_SERVER}`);
}
export function authFailedError(error) {
  logger.error(`Authentication request failed`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.AUTH_FAILED}`);
}
export function invalidJwtError(error) {
  logger.error(`Invalid or expired authentication`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.CLIENT_FORBIDDEN}`);
}
export function missingFeatureFlagsError(error) {
  logger.error(`Failed to obtain feature flags`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.FEATURE_FLAGS_MISSING}`);
}
export function missingListingValidationError(error) {
  logger.error(`Failed to obtain listing validation result`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.LISTING_VALIDATION_RESULT_MISSING}`);
}
export function missingPricingValidationError(error) {
  logger.error(`Failed to obtain pricing validation result`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.PRICING_VALIDATION_RESULT_MISSING}`);
}
export function badPublisherError(error) {
  logger.error(`Failed to obtain listing validation result`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.BAD_PUBLISHER}`);
}
export function missingTrialTemplateError(error) {
  logger.error(`Failed to obtain the listing's trial template`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.MISSING_TRIAL_TEMPLATE}`);
}
export function missingSolutionError(error) {
  logger.error(`Failed to obtain the listing's solution`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.MISSING_SOLUTION}`);
}
export function logoutError(error) {
  logger.error(`Failed to logout`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.FAILED_LOGOUT}`);
}
export function unknownListingTypeError(error) {
  logger.error(`Unknown listing techology type`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.UNKNOWN_LISTING_TYPE}`);
}
export function missingListingStepComponentError(error) {
  logger.error(`Missing listing step component`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.MISSING_LISTING_EDITOR_STEP_COMPONENT}`);
}
export function missingListingSchemaStepErrorMap(error) {
  logger.error(`Missing listing schema step error map`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.MISSING_LISTING_SCHEMA_STEP_ERROR_MAP}`);
}
export function notImplementedError(error) {
  logger.error(`Feature is not implemented or is disabled`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.NOT_IMPLEMENTED}`);
}
export function missingSecurityReviewValidationError(error) {
  logger.error(`Failed to obtain security review validation result`);
  if (error) {
    logger.debug(String(error));
  }
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.SECURITY_REVIEW_VALIDATION_RESULT_MISSING}`);
}
export function invalidMarketplaceError(marketplace) {
  logger.error(`Invalid marketplace '${marketplace}', valid values are: ${JSON.stringify(schemas['listing/extensions/force/listings/Listing'].get().properties.marketplace.enum)}`);
  navigate(`${ERROR_ROUTE}?code=${ERROR_CODES.INVALID_MARKETPLACE}`);
}
export function failedToSavePublisherError(publisher) {
  logger.error(`Failed to save publisher with id '${publisher.external_id}', it's likely to be missing internal contact info`);
  navigate(`${PUBLIC_URL}${ERROR_ROUTE}?code=${ERROR_CODES.FAILED_TO_SAVE_PUBLISHER_ON_LISTING_DETAIL_INIT}`);
}